// @ts-nocheck
import { createHandlerChainRunner, Handler } from "@toolkit/Modules/client-framework/HandlerCreator";

export const DispatchClearSubmittedUploadedOrder: Handler = props => {
    props.dispatch({
        type: "Greif/Components/GreifOrderUpload/ClearSubmittedUploadedOrder",
    });
};

export const chain = [DispatchClearSubmittedUploadedOrder];

const clearSubmittedUploadedOrder = createHandlerChainRunner(chain, "ClearSubmittedUploadedOrder");
export default clearSubmittedUploadedOrder;
